<div class="lp-iframe-activity" style="width: 100%; height: 100%">
  <iframe #frame [src]="url()" [title]="activity().name" style="width: 100%; height: 100%"></iframe>
</div>
